import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { FaviconService } from '../favicon.service';
import { LoginService } from '../security/login.service';
import { RefundRequest } from '../refund-request';
import { RefundRequestListItem } from '../refund-request-list-item';

@Component({
  selector: 'app-refund-requests',
  templateUrl: './refund-requests.component.html',
  styleUrls: ['./refund-requests.component.css']
})
export class RefundRequestsComponent implements OnInit {

  requests: RefundRequestListItem[] = [];

  constructor(
    private httpService: HttpService,
    private favicon: FaviconService,
    private loginService: LoginService,
  ) {
    this.loginService.activatedNavigationComponent = true;
    this.favicon.sbms();
  }

  ngOnInit() {
    this.httpService.getRefundRequests().subscribe(res => {
      this.requests = res;
      for(let request of this.requests){
        let bookingIds: string = "";
        let isFirst = true;
        for(let bookingId of request.bookingIds){
          if(!isFirst){
            bookingIds = bookingIds + ", " + bookingId.label;
          } else {
            bookingIds = bookingId.label.toString();
          }
          isFirst = false;
        }
        request.lvmsBookingId = bookingIds;
      }
    });
  }

  downloadPdf(request: RefundRequest){
    this.httpService.getRefundRequestPdf(request.id!).subscribe(blob => {
      let pdfUrl = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = pdfUrl;
      link.download = "Refund_Request_" + request.id + ".pdf";
      link.click();  
    });
  }

}
